/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";

export const LanguageSelectorIcon = ({ className }: { className?: string }) => (
  <i className={className}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        {/* // SA-1007 restyling language selector: start */}
        <rect width="16" height="16" fill="white" />
        {/* // SA-1007 restyling language selector: end */}
      </mask>

      <mask id="mask1" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        {/* // SA-1007 restyling language selector: start */}
        <rect width="16" height="16" fill="white" />
        {/* // SA-1007 restyling language selector: end */}
      </mask>
      <g mask="url(#mask1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
          fill="white" // SA-1007 restyling language selector
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.832 8C13.832 8.27614 13.6082 8.5 13.332 8.5L2.66537 8.5C2.38922 8.5 2.16537 8.27614 2.16537 8C2.16537 7.72386 2.38922 7.5 2.66537 7.5L13.332 7.5C13.6082 7.5 13.832 7.72386 13.832 8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.83203 7.81591C4.83203 4.94781 6.74376 2.92459 7.71483 2.25488L8.28256 3.0781C7.47586 3.63444 5.83203 5.38746 5.83203 7.81591C5.83203 10.2574 7.48979 12.263 8.31748 12.948L7.67991 13.7184C6.72983 12.9321 4.83203 10.671 4.83203 7.81591Z"
          fill="white" // SA-1007 restyling language selector
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.168 7.81591C11.168 4.94781 9.25624 2.92459 8.28517 2.25488L7.71744 3.0781C8.52414 3.63444 10.168 5.38746 10.168 7.81591C10.168 10.2574 8.51021 12.263 7.68252 12.948L8.32009 13.7184C9.27017 12.9321 11.168 10.671 11.168 7.81591Z"
          fill="white" // SA-1007 restyling language selector
        />
      </g>
    </svg>
  </i>
);
